export var isMultipleParams = function isMultipleParams(params) {
  return !!params.multiple;
};
export var isNotMultipleParams = function isNotMultipleParams(params) {
  return !params.multiple;
};
export var getTextColor = function getTextColor(value, error, disabled, invert) {
  if (error) {
    return 'error';
  }
  if (disabled) {
    return invert ? 'disabled-fake-invert' : 'disabled';
  }
  if (!value) {
    return invert ? 'tertiary-fake-invert' : 'tertiary';
  }
  return invert ? 'primary-fake-invert' : 'primary';
};
export var getIconColor = function getIconColor(_ref) {
  var disabled = _ref.disabled,
    invert = _ref.invert;
  if (disabled) {
    return invert ? 'disabled-fake-invert' : 'disabled';
  }
  return invert ? 'tertiary-fake-invert' : 'tertiary';
};